<a
  class="link-button"
  [class.padding]="!removeSpacing()"
  [class.link-button--inverted]="variant() === 'inverted'"
  [class.link-button--danger]="variant() === 'danger'"
  [routerLink]="routerLink()"
  [href]="href()"
  [target]="target()"
  [tabindex]="disabled() ? -1 : null"
>
  {{ text() }}
</a>
